import { Product, Shops } from '@infrab4a/connect';
import { FormUtil } from 'src/app/utils/form.util';

export function asProductArray(
  value: Array<Partial<Product>> | null | undefined | unknown
): Partial<Product>[] {
  return Array.isArray(value) ? value : [];
}

export function asIdArray(
  value: Array<string | number> | null | undefined | unknown
): Array<string | number> {
  return Array.isArray(value) ? value : [];
}

export function mapMostRelevantProducts(
  productIds: Array<string | number> | null | undefined | unknown,
  categoryProducts: Array<Partial<Product>> | undefined | unknown
): Partial<Product>[] {
  const ids = asIdArray(productIds);
  const products = asProductArray(categoryProducts);
  if (!ids.length) return [];

  return ids
    .map((id) => products.find((product) => product.id === id))
    .filter((product): product is Partial<Product> => Boolean(product));
}

export function filterProductsForMostRelevantSelection(
  categoryProducts: Array<Partial<Product>> | undefined | unknown,
  selectedProducts: Array<Partial<Product>> | undefined | unknown
): Partial<Product>[] {
  const selected = asProductArray(selectedProducts);

  return [...asProductArray(categoryProducts)]
    .filter(
      (product) =>
        !selected.some((selectedProduct) => selectedProduct?.id === product?.id)
    )
    .sort(compareProductsByNameThenId);
}

export function buildMostRelevantsByShop(
  shops: Array<{ value: Shops }> | undefined | unknown,
  categoryProducts: Array<Partial<Product>> | undefined | unknown,
  mostRelevantsIds:
    | Partial<Record<string, Array<string | number> | null>>
    | undefined
    | unknown
): {
  mostRelevants: Record<string, Partial<Product>[]>;
  productsForSelection: Record<string, Partial<Product>[]>;
} {
  const selectedProductsByShop: Record<string, Partial<Product>[]> = {};
  const availableProductsByShop: Record<string, Partial<Product>[]> = {};
  const shopList = Array.isArray(shops) ? shops : [];
  const idsByShop =
    mostRelevantsIds && typeof mostRelevantsIds === 'object'
      ? (mostRelevantsIds as Record<string, unknown>)
      : {};

  shopList.forEach((shop) => {
    const shopKey = shop?.value;
    if (!shopKey) return;

    selectedProductsByShop[shopKey] = mapMostRelevantProducts(
      idsByShop[shopKey],
      categoryProducts
    );
  });

  shopList.forEach((shop) => {
    const shopKey = shop?.value;
    if (!shopKey) return;

    availableProductsByShop[shopKey] = filterProductsForMostRelevantSelection(
      categoryProducts,
      selectedProductsByShop[shopKey]
    );
  });

  return {
    mostRelevants: selectedProductsByShop,
    productsForSelection: availableProductsByShop
  };
}

function compareProductsByNameThenId(
  product1: Partial<Product>,
  product2: Partial<Product>
): number {
  const name1 = FormUtil.semAcento(product1?.name).toUpperCase();
  const name2 = FormUtil.semAcento(product2?.name).toUpperCase();
  if (name1 < name2) return -1;
  if (name1 > name2) return 1;
  return Number(product1.id) - Number(product2.id);
}
